import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCyberCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 11,
	fill: "currentColor",
	viewBox: "0 0 14 11",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M13.69.527a1 1 0 0 1 .033 1.413l-7.875 8.25a1 1 0 0 1-1.43.017L.293 6.082a1 1 0 0 1 1.414-1.414l3.401 3.401L12.277.56A1 1 0 0 1 13.69.528",
		clipRule: "evenodd"
	})
});
export default SvgCyberCheck;
